import Vue from 'vue';

export default Vue.component('invoice-week-item', {
  name: 'MergeableInvoiceItem',
  props: {
    'invoice': { type: Object, required: true }
  },
  data () {
    return {
      isEditing: false
    };
  },
  computed: {
    isPotential (): boolean {
      const invoiceId = this.invoice.invoiceId;
      return !(invoiceId && Number(invoiceId) > 0);
    },
    personColor (): any {
      return {
        'color-yellow': this.isPotential || !this.invoice.fullyPaid,
        'color-green': this.invoice.fullyPaid
      };
    }
  },
  methods: {
    select() {
      this.invoice.selected = !this.invoice.selected;
      this.$emit('invoice-selection-changed', this.invoice);
    }
  }
});



// WEBPACK FOOTER //
// ./src/components/invoice/merge/MergeableInvoiceItem.ts